// @ vendors
const Immutable = require('immutable');

// @ constants
const {
    INSURANCE_REQUEST_OVERALL_VIEW_REQUEST,
    INSURANCE_REQUEST_OVERALL_VIEW_SUCCESS,
    INSURANCE_REQUEST_OVEARLL_VIEW_FAILURE,
    CLEAR_INSURANCE_REQUEST_OVERALL_VIEW
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => Immutable.fromJS({
    insurances: Immutable.List(),
    isFetching: false,
    fulfilled: false,
    error: ''
});

const insuranceRequestLanding = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_OVERALL_VIEW_REQUEST:
            return state.merge({
                isFetching: true
            });

        case INSURANCE_REQUEST_OVERALL_VIEW_SUCCESS:
            const policies = Immutable.fromJS(action.data.policyInfo);
            const insurances = state.get('insurances')
                .concat(policies)

            return state.mergeDeep({
                insurances,
                isFetching: false,
                error: '',
                fulfilled: action.data.lastPage
            });

        case INSURANCE_REQUEST_OVEARLL_VIEW_FAILURE:
            return state.merge({
                error: action.data.error,
                isFetching: false
            });

        case CLEAR_INSURANCE_REQUEST_OVERALL_VIEW:
            return state.merge({
                insurances: [],
                fulfilled: false
            });

        default:
            return state
    }
};

module.exports = insuranceRequestLanding;
module.exports.setInitialState = setInitialState;
